import lozad from 'lozad';
import * as basicLightbox from 'basiclightbox';
import { getElement, getElements, ifSelectorExist, ready } from './utils';
import { cf7Events } from './cf7-events';


const observer = lozad();
observer.observe();

const m = document.getElementById('mob_menu');
const mo = document.getElementById('mm_over');
const mobileMenuBtn = document.querySelector('.mobile_menu_toggle');
const mobileMenuClose = document.querySelector('.mobile_menu_close');

function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    if (!document.getElementById('header').classList.contains('scrolled')) {
      document.getElementById('header').className += ' scrolled ';
    }
  } else {
    document.getElementById('header').classList.remove('scrolled');
  }
}

function showMobMenu(evt) {
  evt.preventDefault();
  m.className += ' active';
  mo.className += ' active';
}

function hideMobMenu(evt) {
  evt.preventDefault();
  m.classList.remove('active');
  mo.classList.remove('active');
}

window.onscroll = function onScrollFunction() {
  scrollFunction();
};

mobileMenuBtn.addEventListener('click', showMobMenu, false);

mobileMenuClose.addEventListener('click', hideMobMenu, false);

mo.addEventListener('click', hideMobMenu, false);

const buttonIframe = getElement('.mike-morse-video-block');

if (ifSelectorExist(buttonIframe)) {
  buttonIframe.onclick = () => {
    console.log(basicLightbox)
    basicLightbox
      .create(
        '<iframe width="80%" height="100%" src="https://www.youtube.com/embed/OXfzCMstVkg" frameborder="0" allowfullscreen></iframe>',
      )
      .show();
  };
}

const buttonsIframeLsaPage = getElements('.lsa-page--video-block');  // Note that the variable is now plural: buttonsIframeLsaPage

function onYouTubeIframeAPIReady() {
  if (ifSelectorExist(buttonsIframeLsaPage)) {  // Updated function name to plural: ifSelectorsExist
    Array.from(buttonsIframeLsaPage).forEach(button => {
      button.addEventListener('click', () => {
        let videoId = button.getAttribute('data-youtube-id');
        instance = basicLightbox.create(
          `
                    <div style="position: relative;">
                        <div id="player"></div>
                        <button id="basicLightbox--close-icon">
                            &times;
                        </button>
                    </div>
                    `
        );

        instance.show();

        // Event listener for the close button
        const closeIcon = document.getElementById('basicLightbox--close-icon');
        if (closeIcon) {
          closeIcon.addEventListener('click', closeLightbox);
        }

        player = new YT.Player('player', {
          height: '100%',
          width: '80%',
          videoId: videoId,
          events: {
            'onReady': onPlayerReady
          }
        });
      });
    });
  }
}


function onPlayerReady(event) {
  event.target.playVideo();
  event.target.unMute();
}

// Function to close the lightbox
function closeLightbox() {
  if (instance) {
    instance.close();
  }
}

// Event listener for the ESC key
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' || event.keyCode === 27) {
    closeLightbox();
  }
});

let preloader = document.querySelector(".preloader");
if (ifSelectorExist(preloader)) {
  window.addEventListener("load", function () {
    // Find the preloader element and hide it
    preloader.style.display = "none";
  });
}

ready(() => {
  cf7Events();
  onYouTubeIframeAPIReady();
});